module.exports = __webpack_public_path__ + "img/593E2C_E5D8A9_BC9F79_9F8A68-256px.5e240cc3.png";